module.exports = __webpack_public_path__ + "19b4ed96ba4cded5eb6923bc144d8f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/i_delete.png
// module id = 280
// module chunks = 0